var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "setting" } } },
                  [_c("a", [_vm._v("システム設定")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("照合ログ編集")])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message_success
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_success) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message_error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_error) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-3 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("照合ログID")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accessLogId,
                              expression: "accessLogId"
                            }
                          ],
                          staticClass: "col-xs-10 col-sm-6",
                          attrs: {
                            type: "text",
                            id: "form-field-1",
                            placeholder: "照合ログID",
                            disabled: ""
                          },
                          domProps: { value: _vm.accessLogId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.accessLogId = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-3 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ログ名称")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configLogInfor.logLabel,
                              expression: "configLogInfor.logLabel"
                            }
                          ],
                          staticClass: "col-xs-10 col-sm-6",
                          attrs: {
                            type: "text",
                            id: "form-field-1",
                            placeholder: "ログ名称"
                          },
                          domProps: { value: _vm.configLogInfor.logLabel },
                          on: {
                            keyup: _vm.updateStatus,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.configLogInfor,
                                "logLabel",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "col-sm-3 control-label no-padding-right",
                        attrs: { for: "form-field-1" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-9" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "setting" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button", disabled: _vm.notEdit },
                              on: { click: _vm.validateBeforeSubmit }
                            },
                            [
                              _vm._v(
                                "\n                  編集を保存\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              staticStyle: {
                                background: "red!important",
                                "border-color": "red!important"
                              },
                              attrs: {
                                type: "button",
                                disabled: _vm.configLogInfor.isDefault
                              },
                              on: {
                                click: function($event) {
                                  _vm.deleteConfig()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  初期化する\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("照合ログ編集")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-offset-3 col-md-9" }, [
      _c("span", { staticClass: "error_m", attrs: { id: "model_error" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-298c67ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298c67ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/configLogEdit.vue
// module id = null
// module chunks = 